import { render, staticRenderFns } from "./HeaderCard.vue?vue&type=template&id=11bd38f4&scoped=true&"
import script from "./HeaderCard.vue?vue&type=script&lang=js&"
export * from "./HeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCard.vue?vue&type=style&index=0&id=11bd38f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bd38f4",
  null
  
)

export default component.exports